export const getYesterdayDateDDMMYYYY = () => {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  const day = String(yesterday.getDate()).padStart(2, "0");
  const month = String(yesterday.getMonth() + 1).padStart(2, "0");
  const year = yesterday.getFullYear();
  return `${day}/${month}/${year}`;
};

export const formatDateToDDMMYYYY = (value) => {
  if (!value || value === "—" || value === "-") return "—";

  const str = String(value).trim();
  const slashMatch = str.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (slashMatch) return str;

  const dashMatch = str.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (dashMatch) {
    const [, year, month, day] = dashMatch;
    return `${day}/${month}/${year}`;
  }

  const parsed = new Date(str);
  if (Number.isNaN(parsed.getTime())) return str;

  const day = String(parsed.getDate()).padStart(2, "0");
  const month = String(parsed.getMonth() + 1).padStart(2, "0");
  const year = parsed.getFullYear();
  return `${day}/${month}/${year}`;
};

export const toDateMillis = (value) => {
  if (value === null || value === undefined || value === "" || value === "N/A" || value === "-" || value === "—") {
    return Number.POSITIVE_INFINITY;
  }

  const raw = String(value).trim();
  const primary = raw.includes(" - ") ? raw.split(" - ")[0].trim() : raw;

  const ddmmyyyy = primary.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (ddmmyyyy) {
    const [, day, month, year] = ddmmyyyy;
    const parsed = new Date(`${year}-${month}-${day}T00:00:00`);
    return Number.isNaN(parsed.getTime()) ? Number.POSITIVE_INFINITY : parsed.getTime();
  }

  const parsed = new Date(primary);
  return Number.isNaN(parsed.getTime()) ? Number.POSITIVE_INFINITY : parsed.getTime();
};

export const compareDateValues = (left, right) => toDateMillis(left) - toDateMillis(right);
